import ForgotPasswordContainer from "./components/forgotPassword/ForgotPasswordContainer";
import ResetPasswordContainer from "./components/forgotPassword/ResetPasswordContainer";
import LoginContainer from "./components/login/LoginContainer";

const publicRoutes = [
  {
    title: "Forgot password",
    path: "/forgot-password",
    component: ForgotPasswordContainer,
    exact: true
  },
  {
    title: "Reset password",
    path: "/reset-password/:token",
    component: ResetPasswordContainer,
    exact: true
  }
];

export default publicRoutes;
